import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import Boomerang from '~/src/components/svg/general/Boomerang';
import Link from '~/src/components/link/Link';

import {classNames} from '~/src/utilities/helpers/css';
import {getVideoFront} from '~/src/utilities/helpers/video';
import {SitemapContext} from '~/src/components/context/SitemapContext';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import {getCategoryUrl} from '~/src/utilities/helpers/link';

import css from './Breadcrumb.module.scss';

const getCrumbs = (mainCategoryId, sitemap) => {
    let crumbs = [];
    let category = sitemap.getCategoryBy({categoryId: mainCategoryId});

    while (category) {
        crumbs.unshift({
            href: category.fullUrlPath === 'video' ? getVideoFront(sitemap.all).fullUrlPath : category.fullUrlPath,
            name: category.name
        });
        category = sitemap.getCategoryBy({categoryId: category.parent});
    }

    return crumbs.filter((crumb) => crumb);
};

const Breadcrumb = ({mainCategoryId, title}) => {
    const sitemap = useContext(SitemapContext);
    const {siteArea} = useContext(SettingsContext);

    const crumbs = getCrumbs(mainCategoryId, sitemap);

    if (!crumbs.length) {
        return null;
    }

    const breadcrumbItemClass = classNames(css, 'breadcrumbItem', siteArea);

    if (!crumbs.some((crumb) => crumb.name === 'Front')) {
        crumbs.unshift({href: '/', name: 'Front'});
    }

    if (title) {
        crumbs.push({name: title});
    }

    return (
        <div className={css.breadcrumb}>
            {crumbs.map((crumb, index) => {
                return (
                    <span key={index} className={breadcrumbItemClass}>
                        {index + 1 < crumbs.length ? <Link href={getCategoryUrl(crumb.href)}>{crumb.name}</Link> : crumb.name}
                        {index + 1 < crumbs.length && <Boomerang />}
                    </span>
                );
            })}
        </div>
    );
};

if (process.env.NODE_ENV === 'development') {
    Breadcrumb.propTypes = {
        mainCategoryId: PropTypes.number
    };
}

export default Breadcrumb;
